import { render, staticRenderFns } from "./LactationDetails.vue?vue&type=template&id=5c7e7322&scoped=true&"
import script from "./LactationDetails.vue?vue&type=script&lang=js&"
export * from "./LactationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e7322",
  null
  
)

export default component.exports